/** @format */
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfSelectorComponent } from '@dsg-tech/homefield-angular';
import { SelectedFilter } from '../models';

@Component({
	selector: 'product-reviews-toggle-select',
	templateUrl: './review-toggle-select.component.html',
	styleUrl: './review-toggle-select.component.scss',
	imports: [CommonModule, HmfSelectorComponent]
})
export class ReviewToggleSelectComponent {
	@Input() isMobile = false;
	@Input() content = '';
	@Input() filterName = '';
	@Input() ariaLabel = '';
	@Input() circleVariant = 'medium';
	@Input() selected = false;

	selector = 'rectangular';
	contained = true;

	@Output() toggleEvent = new EventEmitter<SelectedFilter>();

	toggleSelect() {
		this.toggleEvent.emit({ name: this.filterName, value: !this.selected });
	}
}
